export default {
    voltar: 'Volver',
    listagem: 'Listado',
    integracoes: {
        atributos: 'Atributos',
        credenciais: 'Credenciales',
        cloud_functions: 'CloudFunctions',
        configuracao_protocolo: 'Configuración de Protocolo',
        estados: 'Estados',
        fabricante: 'Fabricante',
        formatos_arquivos: 'Formatos de Archivo',
        integration_helper: 'Clases Helpers',
        label: 'Integraciones',
        protocolos: 'Protocolos',
        resultados_descartaveis: 'Resultados Desechables',
        resultados_controle_descartaveis: 'Contenedores de Control',
        resultados_editaveis: 'Resultados Editables',
    },
    triggers: 'Triggers',
    dexpara:{
        label: 'De X A',
        ordem: 'Exámenes de Pedidos',
        resultado: 'Exámenes de Resultados',
        materiais: 'Materiais',
        complements: 'Complementos',
        metodos: 'Métodos',
        exame_resultado: 'Valor del Resultado',
        tipo: 'Por tipo',
        tipo_create: 'Tipo de Registro',
        result_range_create: 'Rango de Resultados',
        result_conversion_create: 'Conversión de Resultados'
    },
    equipamentos: {
        label: 'Equipo',
        ranges: 'Rangos',
        criar_range: 'Crear rango',
        permissoes: 'Permisos'
    },
    monitores: {
        label: 'Monitores',
        tipo: 'VNS por tipo',
        fila_atendimento: 'Cola de Servicio',
        lista: 'Lista de Monitores',
        ordem_resultado: 'Orden / Resultado',
        ordem_resultado_apoio: 'Orden / Resultado - Apoyo',
        ordem_resultado_lis: 'Orden / Resultado - Lis',
        etiquetas_apoio: 'Soporte de Etiquetas',
        revisar_resultado: 'Resultado de la Revisión'
    },
    tuevs: {
        label: 'TUEVS',
        dashboard: 'Dashboard',
        importar_exames_clientes_cadastrados: 'Importar Exámenes de Clientes',
        componentes: 'Componentes',
        exames: 'Examenes',
        materiais: 'Materiales',
        complements: 'Complementos',
        metodos: 'Métodos',
        escalas: 'Escamas',
        tempos: 'Tiempo',
        examresult: 'Valor del Resultado',
    },
    loinc: {
        label: 'LOINC',
        listagem: 'Listado',
        importar_csv: 'Importar CSV',
        importar_traducoes: 'Importar CSV desde Traducciones'
    },
    rnds: {
        listar: 'Lista de Transmisiones',
        transmitir: 'Transmitir Resultado(s)'
    },
    interopera: {
        transmitir: 'Transmitir Resultado(s)'
    },
    core: {
        label: "Veus Saúde",
        companies: 'Empresas',
        careunits: 'Unidades',
        sector: 'Sector'
    },
    language: {
        select: 'Seleccione el Idioma'
    },
    auditoria: {
        label: 'Auditoría',
        logs: 'Logs'
    }
}
